import React, { Fragment, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import {
  dateTimeFieldToDate,
  getDateToday,
} from "../../../Utils/externalFunctions";
import DataTable from "react-data-table-component";
import EditStatusTransaksi from "./EditStatusTransaksiModal";
import TransaksiSubHeaderComponent from "../../DataTableComponents/TransaksiSubHeaderComponent";
import { customStyles } from "../../DataTableComponents/CustomStyle";
import { filterSearch, filterStatus } from "../../../Utils/FilterItems";
import { useThemeContext } from "../../../Context/ThemeContext";
import getTransaksiColumns from "../constants/getTransaksiColumns";
import DeleteTransaksiModal from "./DeleteTransaksiModal";
import useAxios from "../../../Utils/useAxios";

const Transaksi = ({ data, pending, refreshTransaksi }) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedTransaksi, setSelectedTransaksi] = useState(null);
  const [editStatusModalOpen, setEditStatusModalOpen] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [selectedStatusTransaksi, setselectedStatusTransaksi] = useState(0);
  const [selectedFilterUnitKerja, setSelectedFilterUnitKerja] = useState("");
  const [selectedFilterTanggal, setSelectedFilterTanggal] = useState("");

  const axiosInstance = useAxios()
  const { themeContext } = useThemeContext();

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const toggleEditStatusModal = () =>
    setEditStatusModalOpen(!editStatusModalOpen);

  const handleEditStatusTransaksi = async (transaksi) => {
    setSelectedTransaksi(transaksi);
    toggleEditStatusModal();
  };

  const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen);

  const handleDeleteTransaksi = async (transaksi) => {
    setSelectedTransaksi(transaksi);
    toggleDeleteModal();
  };

  const filterTransaksiItems = (items) => {
    const searchCategories = ["id_transaksi", "dibayarkan_ke", "keterangan"];
    const filteredItems = items
      .filter(filterSearch(searchCategories, filterText))
      .filter(filterStatus("id_status_transaksi", selectedStatusTransaksi))
      .filter(filterSearch(["id_unit_kerja"], selectedFilterUnitKerja))
      .filter(filterSearch(["tanggal_transaksi"], selectedFilterTanggal));
    return filteredItems;
  };

  const conditionalRowStyles = [
    {
      when: (row) =>
        dateTimeFieldToDate(row.tanggal_diajukan) === getDateToday("original"),
      style: (row) => ({
        backgroundColor: row.tanggal_diajukan ? "pink" : "red",
      }),
    },
  ];

  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <DataTable
              columns={getTransaksiColumns({
                themeContext,
                handleEditStatusTransaksi,
                handleDeleteTransaksi,
                axiosInstance
              })}
              data={filterTransaksiItems(data.transaksiList)}
              pagination
              paginationResetDefaultPage={resetPaginationToggle}
              selectableRowsHighlight
              highlightOnHover
              subHeader
              customStyles={customStyles}
              conditionalRowStyles={conditionalRowStyles}
              subHeaderComponent={
                <TransaksiSubHeaderComponent
                  handleClear={handleClear}
                  filterText={filterText}
                  setFilterText={setFilterText}
                  setselectedStatusTransaksi={setselectedStatusTransaksi}
                  setSelectedFilterUnitKerja={setSelectedFilterUnitKerja}
                  setSelectedFilterTanggal={setSelectedFilterTanggal}
                  unitKerja={data.unitKerja}
                />
              }
              subHeaderAlign="right"
              persistTableHead
              progressPending={pending}
              theme={themeContext}
            />
          </Col>
        </Row>
      </Container>

      {selectedTransaksi && (
        <EditStatusTransaksi
          editStatusModalOpen={editStatusModalOpen}
          toggleEditStatusModal={toggleEditStatusModal}
          selectedTransaksi={selectedTransaksi}
          refreshTransaksi={refreshTransaksi}
        />
      )}

      {selectedTransaksi && (
        <DeleteTransaksiModal
          isOpen={deleteModalOpen}
          toggle={toggleDeleteModal}
          selectedTransaksi={selectedTransaksi}
          refreshTransaksi={refreshTransaksi}
        />
      )}
    </Fragment>
  );
};
export default Transaksi;
